import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StoneTypeForm from '../../../../components/masters/stoneAttribute/stoneType/StoneTypeForm';
import StoneTypeTable from '../../../../components/masters/stoneAttribute/stoneType/StoneTypeTable';
import { fetchStoneTypes, addStoneType, updateStoneType, deleteStoneType, setStoneTypeEdit, clearStoneTypeEdit } from '../../../../redux/actions/masters/stoneAttribute/stoneType/stoneTypeAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};
const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};
const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};
const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};
const responsiveStyle = `
@media (max-width: 900px) {
  .stone-type-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .stone-type-form, .stone-type-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const StoneTypePage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingStoneType } = useSelector(state => state.stoneType || {});
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);
  const users = useSelector((state) => state.users.list || []);

  useEffect(() => {
    dispatch(fetchStoneTypes());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearStoneTypeEdit());
  };

  const handleSubmit = async (form) => {
    if (editingStoneType && editingStoneType.id) {
      await dispatch(updateStoneType(editingStoneType.id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addStoneType(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (stoneType) => {
    dispatch(setStoneTypeEdit(stoneType));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteStoneType(id));
  };

  const handleCancel = () => {
    dispatch(clearStoneTypeEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      s => s.stone_type_code === code && (!excludeId || s.id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="stone-type-flex">
        <div style={tableContainer} className="stone-type-table">
          <StoneTypeTable
            onNew={handleFormReset}
            stoneTypes={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="stone-type-form">
          <StoneTypeForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingStoneType={editingStoneType}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            checkCodeExists={checkCodeExists}
            users={users}
          />
        </div>
      </div>
    </div>
  );
};

export default StoneTypePage; 